module.exports = __webpack_public_path__ + "static/media/oracle.03b066d0.jpeg";